document.addEventListener('DOMContentLoaded', ()=>{
    document?.querySelectorAll(`.recipes__items__tabs__map_title`)?.forEach((el)=>{
        el?.addEventListener('click', (tg)=>{
            tg.preventDefault();
            let TargetIndex = tg?.currentTarget?.dataset?.index;
            tg.target.closest(`.recipes__items__tabs__map`).querySelectorAll('.recipes__items__tabs__map_title').forEach((el)=>{ el.classList.remove('active') });
            tg.target.closest(`.recipes__items__layout`).querySelectorAll('.recipes__item__tab-content').forEach((el)=>{ el.classList.remove('active') });
            tg?.currentTarget?.classList?.add('active');
            tg.target.closest(`.recipes__items__layout`).querySelector(`.recipes__item__tab-content[data-tab="${TargetIndex}"]`).classList.add('active');
        })
    })

    document?.querySelectorAll(`.filters__recp___buttons_ct`).forEach((el)=>{
        el?.addEventListener('click', (tg)=>{
            tg.preventDefault();
            if( tg.currentTarget.closest(`.filters__recp___buttons`).querySelector(`.filters__content__sidebar`).classList.contains(`active`) ){
                tg.currentTarget.closest(`.filters__recp___buttons`).querySelector(`.filters__content__sidebar`).classList.remove(`active`);
                document.body.classList.remove(`overflow-masked`);
            }else{
                document.querySelectorAll(`.filters__content__sidebar`).forEach((el)=>{ el.classList.remove(`active`) });
                tg.currentTarget.closest(`.filters__recp___buttons`).querySelector(`.filters__content__sidebar`).classList.add(`active`);
                document.body.classList.add(`overflow-masked`);                
            }
        })
    })

    document.addEventListener('click', (e) => {
        const isInsideFilter = e.target.closest(`.filters__recp___buttons`);
        if (!isInsideFilter) {
            document.querySelectorAll(`.filters__content__sidebar`).forEach((el) => {
                el.classList.remove(`active`);
            });
            document.body.classList.remove(`overflow-masked`);
        }
    });
    
    document?.querySelectorAll(`.filters__content__sidebar__closed`).forEach((el) => {
        el?.addEventListener('click', () => {
            document.querySelectorAll(`.filters__content__sidebar`).forEach((sidebar) => {
                sidebar.classList.remove(`active`);
            });
            document.body.classList.remove(`overflow-masked`);
        });
    });    

    const activeFilters = {
        'cook-time': [],
        'difficulty': [],
        'dietary': [],
        'meal-type': [],
        'ingredient-list': [],
        'inspired-by': [],
        'serves': []
    };

    let activeSearchTerms = [];

    function applyFiltersAndSearch() {
    const recipeItems = document.querySelectorAll('.recipes__item__tab-content__items');
    const noMatchEl = document.querySelector('.js-no__recipes__matched');
    let hasVisible = false;
    recipeItems.forEach(card => {
        const tagsArray = (card.getAttribute('data-tags') || '')
        .split(',')
        .map(t => t.trim().toLowerCase());
        const searchMatch = activeSearchTerms.length === 0 ||
        activeSearchTerms.some(term => tagsArray.some(tag => tag.includes(term)));
        const filterMatch = Object.keys(activeFilters).every(key => {
        if (activeFilters[key].length === 0) return true;
        const cardValues = (card.dataset[camelize(key)] || '').split('|').map(v => v.trim());
        return activeFilters[key].some(val => cardValues.includes(val));
        });
        const isVisible = searchMatch && filterMatch;
        card.classList.toggle('hidden', !isVisible);
        if (isVisible) hasVisible = true;
    });

    if (noMatchEl) noMatchEl.classList.toggle('hidden', hasVisible);
    }    

    document.querySelectorAll('.filter-item input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            const filterKey = this.name;
            const filterVal = this.value;
            if (!activeFilters.hasOwnProperty(filterKey)) return;
            if (this.checked) {
                activeFilters[filterKey].push(filterVal);
            } else {
                activeFilters[filterKey] = activeFilters[filterKey].filter(v => v !== filterVal);
            }
            applyFiltersAndSearch();
        });
    });

    function applyFilters() {
        document.querySelectorAll('.recipes__item__tab-content__items').forEach(card => {
            const isMatch = Object.keys(activeFilters).every(key => {
            if (activeFilters[key].length === 0) return true;
            const cardValues = card.dataset[camelize(key)].split('|');
            return activeFilters[key].some(val => cardValues.includes(val));
            });
            card.style.display = isMatch ? '' : 'none';
        });
    }

    function camelize(str) {
        return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    }  

    const difficultyRank = {
        'easy': 1,
        'medium': 2,
        'hard': 3
    };

    function parseTimeToMinutes(val) {
        if (!val) return 9999;
        val = val.trim().toLowerCase();
        if (val.includes('hour')) {
            const parts = val.match(/(\d+)\s*hour[s]?\s*(\d+)?/);
            const hrs = parts ? parseInt(parts[1]) : 0;
            const mins = parts && parts[2] ? parseInt(parts[2]) : 0;
            return (hrs * 60) + mins;
        }
        if (val.includes('min')) {
            const parts = val.match(/(\d+)/);
            return parts ? parseInt(parts[1]) : 9999;
        }
        return 9999;
    }

    function sortArticles(sortValue) {
        const container = document.querySelector('.recipes__item__tab-content__nt');
        const cards = Array.from(container.querySelectorAll('.recipes__item__tab-content__items'));

        cards.sort((a, b) => {
            switch (sortValue) {
            case 'featured':
                return parseInt(a.dataset.index) - parseInt(b.dataset.index);
            case 'quickest first':
                return parseTimeToMinutes(a.dataset.cookTime) - parseTimeToMinutes(b.dataset.cookTime);
            case 'easiest first':
                return (difficultyRank[a.dataset.difficulty] || 99) - (difficultyRank[b.dataset.difficulty] || 99);
            case 'newest first':
                return parseInt(b.dataset.publishedAt) - parseInt(a.dataset.publishedAt);
            case 'a-z':
                return a.dataset.title.localeCompare(b.dataset.title);
            default:
                return 0;
            }
        });
        cards.forEach(card => container.appendChild(card));
        applyFiltersAndSearch();
    }

    document.querySelectorAll('input[name="sort"]').forEach(input => {
        input.addEventListener('change', function () {
            document.querySelectorAll('input[name="sort"]').forEach(el => {
                if (el !== this) el.checked = false;
            });
            sortArticles(this.value.toLowerCase().trim());
            document.querySelectorAll('.filters__content__sidebar').forEach(el => el.classList.remove('active'));
            document.body.classList.remove('overflow-masked');
        });
    });   
      
    const searchInput = document.querySelector('[js-recipes-search]');
    const suggestionsList = document.querySelector('[js-recipes-suggestions]');
    const noMatchEl = document.querySelector('.js-no__recipes__matched');

    if (searchInput && suggestionsList) {
        const recipeItems = document.querySelectorAll('.recipes__item__tab-content__items');
        const allTags = new Set();

        recipeItems.forEach(item => {
            const tags = item.getAttribute('data-tags') || '';
            tags.split(',').forEach(tag => {
            const cleaned = tag.trim().toLowerCase();
            if (cleaned) allTags.add(cleaned);
            });
        });

        function showSuggestions(rawValue) {
            const lastTerm = rawValue.split(/\s+/).pop().toLowerCase().trim();
            if (!lastTerm) { closeSuggestions(); return; }

            const matches = [...allTags].filter(tag =>
            tag.includes(lastTerm) && tag !== lastTerm
            ).slice(0, 6);

            if (matches.length === 0) { closeSuggestions(); return; }

            suggestionsList.innerHTML = matches.map(tag =>
            `<li class="recipes__search__suggestion-item" data-suggestion="${tag}">${highlightMatch(tag, lastTerm)}</li>`
            ).join('');
            suggestionsList.classList.add('active');
        }

        function highlightMatch(tag, term) {
            const idx = tag.indexOf(term);
            if (idx === -1) return tag;
            return tag.slice(0, idx) + `<strong>${tag.slice(idx, idx + term.length)}</strong>` + tag.slice(idx + term.length);
        }

        function closeSuggestions() {
            suggestionsList.innerHTML = '';
            suggestionsList.classList.remove('active');
        }

        function applySuggestion(tag) {
            const parts = searchInput.value.split(/\s+/);
            parts[parts.length - 1] = tag;
            searchInput.value = parts.join(' ') + ' ';
            closeSuggestions();
            searchInput.focus();
            activeSearchTerms = searchInput.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
            applyFiltersAndSearch();
        }

        searchInput.addEventListener('input', (e) => {
            activeSearchTerms = e.target.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
            applyFiltersAndSearch();
            showSuggestions(e.target.value);
        });

        suggestionsList.addEventListener('click', (e) => {
            const item = e.target.closest('[data-suggestion]');
            if (item) applySuggestion(item.getAttribute('data-suggestion'));
        });

        searchInput.addEventListener('keydown', (e) => {
            const items = [...suggestionsList.querySelectorAll('.recipes__search__suggestion-item')];
            const active = suggestionsList.querySelector('.recipes__search__suggestion-item--focused');
            let idx = items.indexOf(active);

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (active) active.classList.remove('recipes__search__suggestion-item--focused');
                items[(idx + 1) % items.length]?.classList.add('recipes__search__suggestion-item--focused');
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (active) active.classList.remove('recipes__search__suggestion-item--focused');
                items[(idx - 1 + items.length) % items.length]?.classList.add('recipes__search__suggestion-item--focused');
            } else if (e.key === 'Enter') {
                if (active) { e.preventDefault(); applySuggestion(active.getAttribute('data-suggestion')); }
            } else if (e.key === 'Escape') {
                closeSuggestions();
            }
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.recipes__items__searchbar_nt')) closeSuggestions();
        });
    }
})